/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';
  //grabbed old models from iphone_15.es5.js
  var old_models = [
    mp.marketing.trends.utils.IPHONE_15,
		mp.marketing.trends.utils.IPHONE_15_PLUS,
    mp.marketing.trends.utils.IPHONE_15_PRO,
    mp.marketing.trends.utils.IPHONE_15_PRO_MAX,
    mp.marketing.trends.utils.OTHER_IPHONE,
  ];
  var release_models = [
    mp.marketing.trends.utils.IPHONE_16,
		mp.marketing.trends.utils.IPHONE_16_PLUS,
    mp.marketing.trends.utils.IPHONE_16_PRO,
    mp.marketing.trends.utils.IPHONE_16_PRO_MAX,
  ];
  var IPhone16 = mp.marketing.trends.widgets.PhoneAdoption.extend({
    get_display_models() {
      return release_models.concat(old_models);
    },
    get_release_models() {
      return release_models;
    },
    get_visible_models() {
      return release_models.concat(old_models.slice(0, 3));
    },
    get_query_name() {
      return mp.marketing.trends.utils.IPHONE_QUERY;
    },
    getDownloadName() {
      return ns.IPhone16.nice_name;
    },
  });

  Object.assign(IPhone16, {
    slug: `iphone_16`,
    nice_name: `iPhone 16 adoption`,
    description: `How quickly will people start using the new iPhone 16 models?`,
  });
  ns.IPhone16 = IPhone16;
});

}.call(window));